import { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Group, User } from "../../../../../types";
import dateHandlder from "../../../../../helpers/dates-hanlder";
import Link from '../../../../../components/Link'
import {
  Backdrop,
  Content,
  H3,
  H2,
  Hello,
  BlockedBadge,
  InfoBox,
  H4
} from './styles'
import { Post } from "../../../../../types/post";
import Icon from "../../../../../components/Icon";
import padlockLockedIcon from '../../../../../assets/icons/padlock.svg'
import { roundedHumanPostUnlockTime, roundedHumanUnlockTime } from "../../../../../helpers/humanUnlockTime";
import { size } from "lodash";

interface ComponentProps {
  userInformation: User
  userSubscriptions
  isLoggedIn: Boolean;
  group: Group;
  groupStates: {
    loading: boolean;
    error: string | boolean;
    success: boolean;
  };
  post: Post
  postStates: {
    loading: boolean;
    error: string | boolean;
    success: boolean;
  };
  currentPage: string
}

const Component = ({
  group,
  post,
  userInformation,
  isLoggedIn,
}: ComponentProps) => {
  const dispatch = useDispatch();
  const [suscriptionEnded, setSuscriptionEnded] = useState<boolean>();

  const isOwnGroup = useMemo(() => {
    const expertId = group?.expert?.id || post?.expert?.id;

    return expertId === userInformation?.expert?.id && !!userInformation?.expert?.id && !!expertId;
  }, [group, post, userInformation]);

  const isUserAuthenticated = useMemo(() => {
    return isLoggedIn || post?.group?.group_type === 'free_experience'
  }, [isLoggedIn, post])

  const isCommunityPost = useMemo(() => {
    return post?.group?.group_type === "community";
  }, [post])


  const isUnlockedPost = useMemo(() => {
    return post?.user_access_data?.is_unlocked
  }, [post])

  const humanReadableTime = useMemo(() => roundedHumanPostUnlockTime(post), [post])


  useEffect(() => {
    if (!!post?.group?.registration_closing_date) {
      setSuscriptionEnded(
        dateHandlder.isExpired(post?.group?.registration_closing_date)
      );
    }
  }, [post]);


  if (isUnlockedPost || isCommunityPost || isOwnGroup) {
    return <></>
  }

  return (
    <Backdrop>
      <Content>
        <div style={{ height: 35 }} />
        <BlockedBadge>
          <Icon icon={padlockLockedIcon} size="16px" color="black" />
          Bloqueado
        </BlockedBadge>
        <div style={{ height: 22 }} />
        <H2>Todavía no podés ver este contenido…</H2>
        <H2>¡pero cada vez falta menos!</H2>
        <div style={{ height: 22 }} />
        <InfoBox>
          Este artículo pertenece a una categoría que desbloquearás en <strong>{humanReadableTime}</strong>.
        </InfoBox>
        <div style={{ height: 22 }} />
        <H4>
          💡 Forma parte del contenido que se activa a medida que avanzás en la membresía. Mientras tanto, podés aprovechar y explorar todo lo que ya tenés disponible.
        </H4>
        <div style={{ height: 35 }} />
        <Link
          href={`/group/${post?.group?.slug}/library/`}
          options={{
            type: "filled",
            size: "lg",
            skin: "white"
          }}
        >
          Explorar la biblioteca
        </Link>
        <div style={{ height: 35 }} />
      </Content>
    </Backdrop>
  );
};

const state = ({ userStore, postStore, groupStore, pageStore }) => {
  const { data: post, states: postStates } = postStore.post;
  const { data: group, states: groupStates } = groupStore.group;
  const { data: userInformation } = userStore.information;
  const { data: userSubscriptions } = userStore.subscriptions;
  const { isLoggedIn } = userStore.isLoggedIn;

  return {
    group,
    groupStates,
    post,
    postStates,
    userInformation,
    userSubscriptions,
    isLoggedIn,
    currentPage: pageStore?.name,
  };
};

export default connect(state)(Component);